export default "__VITE_ASSET__BQIYxLeA__"